module.exports = __webpack_public_path__ + "static/media/background.d06480dc.avif";